import { Select } from "antd";
import { useEffect, useState } from "react";
import { SizeType } from "antd/es/config-provider/SizeContext";
import { useSelector } from "react-redux";
import store from "../../../../controllers/store";
import { find } from "../../../../controllers/store/actions/universities/get-universities-actions";
import { PageSetting } from "../../..";

interface Props {
  onChange: (value: string) => void;
  size?: SizeType;
  onClear: () => void;
  mode?: any;
  defaultValue?: any;
  style?: any;
}
const dispatch = store.dispatch;
const SelectUniversity = (props: Props) => {
  const universitiesState = useSelector((state: any) => state.universities);
  const userState = useSelector((state: any) => state.user);
  useEffect(() => {
    if (userState.user.me.role.name === "Admin") {
      dispatch(
        find(PageSetting.page, -1, {
          filter: {},
        })
      );
    } else {
      dispatch(
        find(PageSetting.page, -1, {
          filter: {},
        })
      );
    }
  }, []);

  return (
    <div style={{ width: "100%" }}>
      <Select
        loading={universitiesState.isLoading}
        {...props}
        allowClear
        size={props.size}
        defaultValue={props?.defaultValue}
        mode="multiple"
        style={props.style}
        onChange={(value: any) => {
          props.onChange(value);
        }}
        options={
          universitiesState?.list?.map((e: any) => ({
            label: e.institution_name,
            value: e.id,
          })) || []
        }
      />
    </div>
  );
};

export default SelectUniversity;
